<template>
  <div style="overflow: auto;height:100%">
    <el-table tooltip-effect="dark" style="width:100%" :data="tableData_" v-loading="loading_">
      <template slot="empty">
        <div id="notDate">
          <img src="../../../assets/imgs/project/project_statistics.png" alt />
          <p>学生完成任务之后才可统计哦</p>
        </div>
      </template>
      <!-- :span-method="arraySpanMethod" 合并行-->
      <el-table-column align="center" type="index" label="序号" min-width="100"></el-table-column>
      <!-- <el-table-column align="center" label="项目名称" prop="projectName"></el-table-column> -->
      <el-table-column align="center" label="任务名称" prop="taskName"></el-table-column>
      <el-table-column align="center" label="任务类型" prop="taskType"></el-table-column>
      <el-table-column align="center" label="完成时间" prop="finishTime" min-width="140"></el-table-column>
      <!-- <el-table-column label="任务类型" prop="taskType" width="92"></el-table-column> -->
      <el-table-column align="center" label="原文字数" prop="sourceWordNum" min-width="100"></el-table-column>
      <el-table-column label="译文字数" prop="targetWordNum" width="100"></el-table-column>
      <el-table-column align="center" label="译员" prop="userName" min-width="100"></el-table-column>
      <el-table-column align="center" label="分数" prop="taskScore" min-width="124"></el-table-column>
      <!-- <el-table-column label="总价/元" prop="totalMoney" width="124"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: [Array]
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
    };
  },
  computed: {
    tableData_() {
      return this.tableData
    },
    loading_() {
      return this.loading
    }
  },
  created() {
  },
  methods: {
  },



};
</script>
<style lang="less" scoped>
</style>
